module.exports = __webpack_public_path__ + "969a34be70f613567aae67388a646c5a.svg";